(function() {
  const form = document.getElementById('signupForm');
  const emailInput = document.getElementById('emailInput');
  const submitButton = document.getElementById('submitButton');
  const errorMessage = document.getElementById('errorMessage');
  const errorText = document.getElementById('errorText');
  const successState = document.getElementById('successState');

  // On Shopify the form does a normal page submit to the storefront's customer (newsletter)
  // endpoint. Shopify's bot protection hooks that submit to attach a captcha token, so it must
  // not be replaced with fetch. The static index.html preview has no backend, so it simulates.
  const isShopify = form && form.hasAttribute('data-shopify');

  let isSubmitting = false;
  const subscribedEmails = new Set();

  // Email validation regex (standard RFC5322 compatible check)
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function reveal(el) {
    if (!el || !el.getBoundingClientRect) return;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < 0 || rect.bottom > vh) {
      el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function showError(message) {
    errorText.textContent = message;
    errorMessage.classList.add('visible');
    emailInput.setAttribute('aria-invalid', 'true');
    emailInput.setAttribute('aria-describedby', 'errorMessage');
    reveal(errorMessage);
  }

  function clearError() {
    if (errorMessage.classList.contains('visible')) {
      errorMessage.classList.remove('visible');
      emailInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-describedby');
    }
  }

  function setLoading(loading) {
    isSubmitting = loading;
    // readOnly rather than disabled: disabled fields are left out of the submitted form
    emailInput.readOnly = loading;
    submitButton.disabled = loading;
    submitButton.classList.toggle('is-loading', loading);
  }

  function trackSignup(email) {
    // GA4 & Meta Pixel. The email is deliberately not sent to GA4 (its terms prohibit PII).
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'sign_up', { method: 'Early Access Waitlist' });
      }
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', { content_name: 'Early Access Waitlist' });
      }
    } catch (err) {
      console.warn('Analytics event dispatch error:', err);
    }

    // Klaviyo integration hooks
    if (!email) return;
    try {
      window.dispatchEvent(new CustomEvent('sunok:subscribed', { detail: { email: email } }));
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Signed Up for Waitlist', { email: email }]);
      }
      if (window.klaviyo) {
        window.klaviyo.identify({ email: email });
      }
    } catch (kErr) {
      console.warn('Klaviyo event dispatch error:', kErr);
    }
  }

  function showSuccess(email) {
    subscribedEmails.add(email);
    trackSignup(email);

    // Animate out email field + button; fade/slide in success message
    form.classList.add('fade-out');
    setTimeout(function() {
      form.style.display = 'none';
      successState.classList.add('visible');
      reveal(successState);
    }, 250);
  }

  function handleFailure(message) {
    setLoading(false);
    showError(message);
    emailInput.focus();
  }

  // Preview-only: brief delay simulating a network request (~300ms)
  function submitSimulated(email) {
    // Test error state requirement (@bad.com or @error.com suffix)
    const isBadDomain = email.endsWith('@bad.com') || email.endsWith('@error.com');
    setTimeout(function() {
      if (isBadDomain) {
        handleFailure('Something went wrong - please try again.');
      } else {
        setLoading(false);
        showSuccess(email);
      }
    }, 300);
  }

  if (form) {
    // Clear error immediately on user input
    emailInput.addEventListener('input', clearError);

    form.addEventListener('submit', function(e) {
      if (!isShopify || isSubmitting) e.preventDefault();
      if (isSubmitting) return;

      const email = emailInput.value.trim().toLowerCase();

      // 1. Validate empty or basic email syntax
      if (!email || !isValidEmail(email)) {
        e.preventDefault();
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      // 2. Check if already subscribed in this session
      if (subscribedEmails.has(email)) {
        e.preventDefault();
        showError("You're already on the list.");
        emailInput.focus();
        return;
      }

      emailInput.value = email;
      // Show loading state so the field cannot be double-submitted
      clearError();
      setLoading(true);
      if (isShopify) {
        // Let the browser submit; remember the email so the next page load can report the signup
        try { sessionStorage.setItem('sunok:pendingEmail', email); } catch (err) {}
      } else {
        submitSimulated(email);
      }
    });

    // Shopify redirects back with ?customer_posted=true and the section renders the success state
    const initialState = form.querySelector('[data-signup-state]');
    if (initialState && initialState.getAttribute('data-posted') === 'true' && /customer_posted=true/.test(window.location.search)) {
      let pendingEmail = null;
      try {
        pendingEmail = sessionStorage.getItem('sunok:pendingEmail');
        sessionStorage.removeItem('sunok:pendingEmail');
      } catch (err) {}
      trackSignup(pendingEmail);
    }

    // Returning via the back button restores the page from cache with the loading state still on
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) setLoading(false);
    });
  }

  // Privacy Policy Modal Handlers
  const openPrivacyModalBtn = document.getElementById('openPrivacyModal');
  const closePrivacyModalBtn = document.getElementById('closePrivacyModal');
  const privacyModal = document.getElementById('privacyModal');

  function openModal() {
    privacyModal.classList.add('is-active');
    privacyModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    closePrivacyModalBtn.focus();
  }

  function closeModal() {
    privacyModal.classList.remove('is-active');
    privacyModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    openPrivacyModalBtn.focus();
  }

  if (openPrivacyModalBtn && closePrivacyModalBtn && privacyModal) {
    openPrivacyModalBtn.addEventListener('click', openModal);
    closePrivacyModalBtn.addEventListener('click', closeModal);

    // Close on backdrop click
    privacyModal.addEventListener('click', function(e) {
      if (e.target === privacyModal) {
        closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && privacyModal.classList.contains('is-active')) {
        closeModal();
      }
    });
  }
})();
